import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Tags from '../../components/Tags'
import format from 'date-fns/format'

function BlogMeta({ category, date, tags }) {
  if (!category || !date || !tags) return null

  return (
    <div className="c-article-footer">
      <p className="c-article-footer__meta">
        Posted in{' '}
        <Link
          className="c-article-footer__meta-link"
          to={'/blog/category/' + category.slug}
          data-uid="blog-category"
        >
          {category.name}
        </Link>{' '}
        on {format(date, 'd MMM, YYYY')}
      </p>
      {tags && <Tags tags={tags} />}
    </div>
  )
}

BlogMeta.propTypes = {
  category: PropTypes.object,
  date: PropTypes.string,
  tags: PropTypes.array,
}

export default BlogMeta
